import * as Yup from 'yup';

export const addPrivilegeSchema = () => {
    return (
        Yup.object({
            role: Yup.string()
                .trim()
                .required('Role is required')
        }));
}
